import { TouchableOpacity, View } from "react-native"
import React from "react"
import SvgIconRetour from "@Components/CustomIcon/SvgIconRetour"
import { useNavigation } from "@react-navigation/native"

const SimpleGoBackBtn = () => {
    const navigation = useNavigation()
    const goBack = () => navigation.goBack()

    return (
        <TouchableOpacity onPress={goBack}>
            <View style={{ padding: 10 }}>
                <SvgIconRetour width={50} height={40} />
            </View>
        </TouchableOpacity>
    )
}

export default SimpleGoBackBtn
